import styled from "styled-components";
import SelectComponent from "../../../components/SelectComponent";

export const StyledSelectComponent = styled(SelectComponent)`
	background: blue;
	display: none;
`;

export const SwitchContainer = styled.div`
	margin-top: 28px;
`;